module.exports = __webpack_public_path__ + "media/categories/35-36282863.png";